var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M84.47,111.19H78.74a3.08,3.08,0,0,1-3.1-3.07,2.93,2.93,0,0,1,.1-.78L78,98.7A6.51,6.51,0,1,1,87,97a6.63,6.63,0,0,1-1.83,1.79l2.22,8.54a3.08,3.08,0,0,1-2.19,3.75,3.15,3.15,0,0,1-.81.1Zm-3-2.86h3a.18.18,0,0,0,.17-.27l-2.51-9.65A1.43,1.43,0,0,1,83,96.72a3.59,3.59,0,1,0-3.77-.63,4,4,0,0,0,1,.63A1.43,1.43,0,0,1,81,98.4l-2.46,9.66a.31.31,0,0,0,0,.19.21.21,0,0,0,.17.08Z","key":1}),React.createElement("path",{"d":"M102.9,73.71H102V60.18a20.45,20.45,0,0,0-40.89-.91c0,.3,0,.6,0,.91V73.71h-.92a10.07,10.07,0,0,0-10.06,10v30a10.08,10.08,0,0,0,10.06,10.06H102.9a10.07,10.07,0,0,0,10-10.06V83.76A10.06,10.06,0,0,0,102.9,73.71ZM64,60.18a17.58,17.58,0,1,1,35.15-.84q0,.42,0,.84V73.71H95.57V60.18a14,14,0,1,0-28.09,0V73.71H64Zm28.76,0V73.71H70.34V60.18a11.19,11.19,0,0,1,22.37-.67C92.72,59.73,92.72,60,92.71,60.18Zm17.38,53.49a7.21,7.21,0,0,1-7.19,7.19H60.16A7.19,7.19,0,0,1,53,113.67h0V83.76a7.2,7.2,0,0,1,7.19-7.19H102.9a7.2,7.2,0,0,1,7.19,7.19Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-fixed-amount.svg
// module id = 289
// module chunks = 0